export const SITE = {
  name: "VPNReviews.ai",
  url: "https://vpnreviews.ai",
  updated: "June 2026",
  email: "editor@vpnreviews.ai",
};

export const AFF = {
  nordvpn: "https://umtugxsg.com/click?trvid=56096",
  surfshark: "https://umtugxsg.com/click?trvid=56097",
  purevpn: "https://umtugxsg.com/click?trvid=38875",
  veepn: "https://umtugxsg.com/click?trvid=56098",
  "adguard-vpn": "https://umtugxsg.com/click?trvid=56099",
};

export const FEATURE_ROWS = [
  { key: "price", label: "Price/mo (2yr)" },
  { key: "servers", label: "Servers" },
  { key: "countries", label: "Countries" },
  { key: "simultaneous", label: "Simultaneous Devices" },
  { key: "audited", label: "No-Log Audited" },
  { key: "killSwitch", label: "Kill Switch" },
  { key: "splitTunnel", label: "Split Tunneling" },
  { key: "streaming", label: "Streaming" },
  { key: "speed", label: "Speed (avg retained)" },
  { key: "wireguard", label: "WireGuard" },
  { key: "threat", label: "Threat Protection" },
  { key: "affiliate", label: "Affiliate Program" },
];

export const VPNS = [
  {
    slug: "nordvpn",
    name: "NordVPN",
    rank: 1,
    score: 9.8,
    badge: "Editor's Choice",
    price: "$3.09",
    link: AFF.nordvpn,
    tagline: "The gold standard for VPNs in 2026.",
    blurb:
      "The gold standard for VPNs in 2026. Fastest speeds, best streaming support, verified no-logs, and a feature set that suits everyone from casual users to security professionals. Starts at $3.09/month.",
    cta: "Get NordVPN",
    details: "30-day money-back guarantee • Up to 10 devices • No logs verified",
    features: {
      price: "$3.09",
      servers: "6,400+",
      countries: "111",
      simultaneous: "10",
      audited: "Yes",
      killSwitch: "Yes",
      splitTunnel: "Yes",
      streaming: "Excellent",
      speed: "95% base",
      wireguard: "Yes (NordLynx)",
      threat: "Advanced",
      affiliate: "Up to 40%",
    },
    pros: [
      "Fastest speeds in our 2026 testing — 95%+ of base connection retained",
      "Unblocks Netflix, Disney+, BBC iPlayer, Hulu and more",
      "Independently audited no-log policy — verified by PricewaterhouseCoopers",
      "NordLynx protocol (WireGuard-based) — best combination of speed and security",
      "6,400+ servers in 111 countries",
    ],
    cons: [
      "Monthly pricing ($12.99) expensive vs committing to 2-year plan",
      "No unlimited simultaneous connections (Surfshark offers this)",
    ],
    miniReview:
      "NordVPN is the best VPN available in 2026. It leads our rankings on speed, security, streaming, and server coverage — and its independently-audited no-log policy provides genuine privacy assurance. In our testing it retained 95.3% of base speed, unblocked every streaming service we threw at it, and its NordLynx protocol delivered the lowest latency of any VPN we tested. Plans start from $3.09/month with a 30-day money-back guarantee.",
  },
  {
    slug: "surfshark",
    name: "Surfshark",
    rank: 2,
    score: 9.2,
    badge: "Best Value",
    price: "$2.29",
    link: AFF.surfshark,
    tagline: "The best value VPN on the market.",
    blurb:
      "The best value VPN on the market. Unlimited simultaneous connections make it ideal for families and multi-device households. Speeds are excellent, streaming support is strong. Starts at $2.29/month.",
    cta: "Get Surfshark",
    details: "30-day money-back guarantee • Unlimited devices",
    features: {
      price: "$2.29",
      servers: "3,200+",
      countries: "100",
      simultaneous: "Unlimited",
      audited: "Yes",
      killSwitch: "Yes",
      splitTunnel: "Yes",
      streaming: "Excellent",
      speed: "93% base",
      wireguard: "Yes",
      threat: "CleanWeb",
      affiliate: "Up to 40%",
    },
    pros: [
      "Unlimited simultaneous connections — best in market",
      "Excellent speeds (93% retention on UK servers)",
      "Strong streaming — unblocks all major services",
      "CleanWeb: ad and tracker blocking included",
      "Independently-audited no-log policy",
      "Very competitive pricing ($2.29/month on 2-year plan)",
    ],
    cons: [
      "Slightly slower than NordVPN on some international servers",
      "Smaller server network (3,200 vs NordVPN's 6,400+)",
      "Fewer specialty servers than NordVPN",
    ],
    miniReview:
      "Surfshark is the best VPN for households and multi-device users. Its unlimited simultaneous connections policy is unique in the market, speeds are excellent (93% retention with WireGuard), streaming is strong, and the no-log policy is independently audited by Deloitte. At $2.29/month on a 2-year plan, it's the best value credible VPN available. NordVPN edges it on raw performance and server coverage, but Surfshark is a worthy #2.",
  },
  {
    slug: "purevpn",
    name: "PureVPN",
    rank: 3,
    score: 8.7,
    badge: "Largest Network",
    price: "$1.99",
    link: AFF.purevpn,
    tagline: "A solid all-rounder with one of the largest server networks.",
    blurb:
      "A solid all-rounder with one of the largest server networks (6,500+ servers in 88 countries). Good streaming performance and competitive pricing. Best for users who travel frequently. Starts at $1.99/month.",
    cta: "Get PureVPN",
    details: "31-day money-back guarantee • Up to 10 devices",
    features: {
      price: "$1.99",
      servers: "6,500+",
      countries: "88",
      simultaneous: "10",
      audited: "Yes",
      killSwitch: "Yes",
      splitTunnel: "Yes",
      streaming: "Good",
      speed: "91% base",
      wireguard: "Yes",
      threat: "Basic",
      affiliate: "Up to 40%",
    },
    pros: [
      "Massive server network — 6,500+ in 88 countries",
      "Very competitive pricing ($1.99/month on 2-year plan)",
      "Good speeds on nearby servers",
      "Audited no-log policy (KPMG)",
      "31-day money-back guarantee",
    ],
    cons: [
      "Streaming reliability slightly below NordVPN/Surfshark",
      "Historical privacy concerns (2017 data disclosure)",
      "Interface less polished than top competitors",
    ],
    miniReview:
      "PureVPN is a solid, affordable VPN that earns its #3 ranking. The 6,500+ server network across 88 countries is genuinely impressive — even slightly larger than NordVPN by raw count — and pricing is among the lowest in the market at $1.99/month. Streaming is good but not as consistently reliable as the top two. If you're price-sensitive or need broad geographic coverage, it's a strong choice.",
  },
  {
    slug: "veepn",
    name: "VeePN",
    rank: 4,
    score: 8.1,
    badge: "Beginner Friendly",
    price: "$2.50",
    link: AFF.veepn,
    tagline: "A user-friendly VPN with unlimited simultaneous connections.",
    blurb:
      "A user-friendly VPN with unlimited simultaneous connections and a clean interface. Good for VPN beginners. Speed and server count trail NordVPN but pricing is competitive. Starts at $2.50/month.",
    cta: "Get VeePN",
    details: "30-day money-back guarantee • Unlimited devices",
    features: {
      price: "$2.50",
      servers: "2,500+",
      countries: "60+",
      simultaneous: "Unlimited",
      audited: "Claimed",
      killSwitch: "Yes",
      splitTunnel: "Yes",
      streaming: "Moderate",
      speed: "85% base",
      wireguard: "Yes",
      threat: "Basic",
      affiliate: "Up to 35%",
    },
    pros: [
      "Unlimited simultaneous connections",
      "Clean, beginner-friendly apps",
      "Competitive pricing at $2.50/month on 2-year plan",
      "WireGuard support",
      "30-day money-back guarantee",
    ],
    cons: [
      "No-log policy not independently audited",
      "Speed trails NordVPN on international connections",
      "Smaller server network than top competitors",
      "Streaming reliability below NordVPN and Surfshark",
    ],
    miniReview:
      "VeePN is a decent entry-level VPN for users who want simplicity and unlimited connections at a low price. Apps are clean and beginner-friendly, WireGuard is supported, and speeds (85% retention locally) are fine for everyday use. The lack of an independent privacy audit is the main concern for serious privacy users. For maximum performance or verified privacy, NordVPN is the stronger choice.",
  },
  {
    slug: "adguard-vpn",
    name: "AdGuard VPN",
    rank: 5,
    score: 7.8,
    badge: "Privacy Stack",
    price: "$2.49",
    link: AFF["adguard-vpn"],
    tagline: "Built-in ad and tracker blocking alongside VPN protection.",
    blurb:
      "Unique proposition: built-in ad and tracker blocking alongside VPN protection. Smaller server network but the integrated privacy stack is compelling for privacy-focused users. Starts at $2.49/month.",
    cta: "Get AdGuard VPN",
    details: "30-day money-back guarantee • 5 devices • Free tier available",
    features: {
      price: "$2.49",
      servers: "500+",
      countries: "45+",
      simultaneous: "5",
      audited: "Yes",
      killSwitch: "Yes",
      splitTunnel: "Yes",
      streaming: "Moderate",
      speed: "80% base",
      wireguard: "Yes",
      threat: "AdGuard DNS",
      affiliate: "Up to 40%",
    },
    pros: [
      "Unique integrated ad + tracker blocking at DNS level",
      "Strong privacy pedigree from AdGuard brand",
      "Clean, polished apps",
      "Free tier available (3GB/month)",
      "Proprietary protocol designed to bypass VPN blocking",
    ],
    cons: [
      "Smallest server network of the five (500 vs 6,400 for NordVPN)",
      "Speed drops on long-distance connections",
      "Only 5 simultaneous connections",
      "Streaming performance below top picks",
      "No independent audit of no-log policy",
    ],
    miniReview:
      "AdGuard VPN earns its place in our top 5 on the strength of its unique privacy stack — DNS-level ad, tracker, and malware blocking built into the VPN itself, powered by the same technology behind AdGuard's 100-million-user ad blocker. The trade-off is a smaller network (500+ servers in 45+ countries) and moderate streaming. Choose AdGuard VPN for its privacy approach; choose NordVPN for everything else.",
  },
];

export const getVpn = (slug) => VPNS.find((v) => v.slug === slug);
export const NORD = VPNS[0];
